import operationLanguages from '../data/operation-languages.json';
import { capitalize } from '@aibees/shared/utils/string';

const OPERATION_LANGUAGES: string[] = operationLanguages;

const getOperationLanguagesOptions = () =>
  OPERATION_LANGUAGES.map((language) => ({
    id: language,
    value: language,
    label: capitalize(language),
  }));

export const OPERATION_LANGUAGES_FILTER_OPTIONS = [
  getOperationLanguagesOptions(),
];
